import { useQuery } from '@tanstack/react-query';

interface SasTokenQuery {
  blob_name: string;
  blob_path: string;
  blob_uri: string;
  sas_token: string;
  blob_endpoint: string;
}

const getSasToken = async () => {
  try {
    const url = `${import.meta.env.VITE_APIM_BASE_URL}/files/v1/token`;
    const response = await fetch(url, {
      headers: {
        'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY}`,
        Container: 'files',
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useSasTokenQuery = () => {
  return useQuery({
    queryKey: ['sasToken'],
    queryFn: async () => (await getSasToken()) as SasTokenQuery,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
